<script setup lang="ts">
import { ref } from 'vue';
import { NButton } from '@nio-fe/lego';
import DevSupportDrawer from '@/components/dev-support/DevSupportDrawer.vue';
const devSupportDrawerInstance = ref();
</script>

<template>
  <div class="micro-debug-tools">
    <n-button size="mini" @click="devSupportDrawerInstance.openDrawer()"
      >开发面板</n-button
    >
    <dev-support-drawer ref="devSupportDrawerInstance" />
  </div>
</template>

<style scoped lang="scss">
.micro-debug-tools {
  display: flex;
  align-items: center;
  :deep(.n-button) {
    margin-left: 2px;
  }
}
</style>
